// extracted by mini-css-extract-plugin
module.exports = {"wrapperMain":"style-module__wrapperMain___fQv7A","wrapperBtn":"style-module__wrapperBtn___EwXnC"};